import React, { useRef } from 'react'
import ReactHtmlParser from 'react-html-parser'
import PropTypes from 'prop-types'
import { striptags } from '../../utilities/base'

const Radio = ({ label, id, onClick, checked, disabled }) => {
  const radioEl = useRef(null)

  const toggleCheck = () => {
    const clickData = {
      clickedEl: radioEl.current,
      isChecked: !checked,
      value: id,
    }

    onClick(clickData)
  }

  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions
    <span onClick={toggleCheck} ref={radioEl} className={`cb-wrap ${disabled ? 'disable' : ''}`}>
      <input
        type="radio"
        disabled={disabled ? 'disabled' : ''}
        id={id}
        onChange={toggleCheck}
        checked={checked}
      />
      <span />
      {/* eslint-disable-next-line jsx-a11y/label-has-for */}
      <label htmlFor={striptags(`${label}-${id}`)}>
        {/* eslint-disable-next-line new-cap */}
        {ReactHtmlParser(label)}
      </label>
    </span>
  )
}

Radio.propTypes = {
  label: PropTypes.string.isRequired,
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  onClick: PropTypes.func.isRequired,
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
}

Radio.defaultProps = {
  checked: false,
  disabled: false,
}

export default Radio
